import React, { Component, createRef } from "react"
import { businessBasicInfo, verifyUsername, getPasswordCreteria } from "../../BackendServices/registrationAPI"
import { withTranslation } from "react-i18next"
import Title from "../common/Title"
import Description from "../common/Description"
import TextInput from "../common/TextInput"
import SelectInput from "../common/SelectInput"
import SuccessScreen from "./SuccessScreen";
import ReCAPTCHA from "react-google-recaptcha"
import CheckBoxRadioInput from "../common/CheckBoxRadioInput"
import PasswordStrengthBar from 'react-password-strength-bar';
import ErrorAlert from "../common/ErrorAlert"
import { encrypt } from "../../BackendServices/generic"

class BusinessBasicInfo extends Component {

    state = {
        userName: '',
        password: '',
        confirmPassword: '',
        preferedLang: '0',
        termsConditions: false,
        preferedLangOptions: ['en_label', 'ar_label'],
        errors: { userName: '', password: '', confirmPassword: '', email: '', recaptcha: '', termsConditions: '' },
        errorType: { userNameClassName: '', passwordClassName: '', confirmPasswordClassName: '', emailClassName: '', recaptchaClassName: '', termsConditionsClassName: '' },
        //formIsValid: false,
        isSuccess: false,
        genericError: null,
        loading: false,
        toolTipMessage: "",
        passRegExpression: "",
    }

    async componentDidMount() {
        let result = await getPasswordCreteria();
        const result1 = JSON.parse(result);
        const userPasswordRules = result1.data.user_password_rules_info;
       /* const descriptionArray = userPasswordRules.tool_tip_info.description;
        const criteriaArray = userPasswordRules.tool_tip_info.criteria_info;*/

         const tooltipText = [...userPasswordRules.tool_tip_info.criteria_info]
        .sort((a, b) => Number(a.priority) - Number(b.priority))
        .map(item => window.lang === "ar" ? item.ar : item.en) .join("<br /><br />");


        await this.setState({
                toolTipMessage: tooltipText,
                passRegExpression: userPasswordRules.reg_expression,
                emailRegex: result1.data.email_reg_rules_info.reg_expression,
            });
       /*     
        if (window.lang === "en") {
            let tooltipText = '';

            descriptionArray.length > 0 && descriptionArray.forEach((item) => {
                let arrayText = item.en === '' ? `${item.en}` : `${item.en}\n\n`;
                tooltipText += arrayText;
            });

            criteriaArray.length > 0 && criteriaArray.forEach(item => {
                let arrayText = `${item.en} \n\n`
                tooltipText += arrayText
            });

            const toolTipMessage_en = tooltipText;

            await this.setState({
                toolTipMessage: toolTipMessage_en,
                passRegExpression: userPasswordRules.reg_expression,
            });
        } else if (window.lang === "ar") {
            let tooltipText = '';

            descriptionArray.length > 0 && descriptionArray.forEach((item) => {
                let arrayText = item.ar === '' ? `${item.ar}` : `${item.ar}\n\n`;
                tooltipText += arrayText;
            });

            criteriaArray.length > 0 && criteriaArray.forEach(item => {
                let arrayText = `${item.ar} \n\n`
                tooltipText += arrayText
            });

            const toolTipMessage_ar = tooltipText;

            await this.setState({
                toolTipMessage: toolTipMessage_ar,
                passRegExpression: userPasswordRules.reg_expression,
            });
        }*/
    }

    handleValidation(formData) {
        let errors = {};
        let errorType = {};
        let formIsValid = false;

        for (var [key, value] of formData) {
            if (key !== 'g-recaptcha-response') {
                if (value === '') {
                    let errKey = `${key}ClassName`;
                    errors[key] = "required";
                    errorType[errKey] = "validation-error";
                }
            }

            // USERNAME
            if (key === 'userName') {
                if (typeof value !== "undefined" && value !== "") {
                    if (this.state.errors.userName !== '') {
                        let errKey = `${key}ClassName`;
                        errors[key] = this.state.errors.userName;
                        errorType[errKey] = "validation-error";
                    }
                }
            }

            // PASSWORD
            if (key === 'password') {
                let passwordRegex = new RegExp(this.state.passRegExpression, "i");

                if (value !== "") {
                    if (!value.match(passwordRegex)) {
                        let errKey = `${key}ClassName`;
                        errors[key] = "password_match_pattern";
                        errorType[errKey] = "validation-error";
                    }
                }
            }

            // CONFIRM PASSWORD
            if (key === 'confirmPassword') {
                if (typeof value !== "undefined" && value !== "") {

                    if (this.state.errors.confirmPassword !== '') {
                        let errKey = `${key}ClassName`;
                        errors[key] = this.state.errors.confirmPassword;
                        errorType[errKey] = "validation-error";
                    }
                }
            }

            //EMAIL
            if (key === 'email') {
                if (typeof value !== "undefined" && value !== "") {
                    let lastAtPos = value.lastIndexOf('@');
                    let lastDotPos = value.lastIndexOf('.');

                    if (!(lastAtPos < lastDotPos && lastAtPos > 0 && value.indexOf('@@') === -1 && lastDotPos > 2 && (value.length - lastDotPos) > 2)) {
                        let errKey = `${key}ClassName`;
                        errors[key] = "invalid_email";
                        errorType[errKey] = "validation-error";
                    }
                }
            }

            if (key === 'g-recaptcha-response') {
                if (!value) {
                    let errKey = `${key}ClassName`;
                    errors['recaptcha'] = "required";
                    errorType[errKey] = "validation-error";
                }
            }

            // TERMS & CONDITIONS
            if (key === 'termsConditions') {
                if (value === 'false') {
                    let errKey = `${key}ClassName`;
                    errors[key] = "required";
                    errorType[errKey] = "validation-error";
                }
            }
        }

        if (JSON.stringify(errors) === '{}') {
            formIsValid = true;
        }

        this.setState({
            errors: errors,
            errorType: errorType
        });

        return formIsValid;
    }

    handaleSubmit = async (e) => {
        let formIsValid = false;
        const formData = new FormData(e.target);

        // ADDING CHECKBOX FIELD
        if (!formData.has('termsConditions')) {
            formData.append("termsConditions", this.state.termsConditions);
        }

        formIsValid = this.handleValidation(formData.entries())
        e.preventDefault();
        if (formIsValid) {
            await this.businessBasicInfo();
        }
    }

    businessBasicInfo = async () => {
        let requestBody = {
            "transactionId": this.props.transactionId,
            "basicInfo": {
                "userName": encrypt(this.state.userName),
                "password": encrypt(this.state.password),
                "preferredLang": this.state.preferedLang === '0' ? 'EN' : 'AR'
            },
            "billingAccountNumber": encrypt(this.props.billingNumber)
        }
        await this.setState({
            loading: true
        })

        try {
            let result = await businessBasicInfo(requestBody)
            await this.setState({
                isSuccess: true,
                loginUrl: result.loginUrl,
                loading: false
            })
        } catch (error) {
            this.setState({
                genericError: error.message,
                loading: false
            })
        }
    }


    handleConfirmPassword = (e) => {
        if (e.target.value !== this.state.password) {
            this.state.errors.confirmPassword = 'password_not_match';
            this.state.errorType.confirmPasswordClassName = 'validation-error';
            this.setState({
                [e.target.name]: e.target.value,
            })
        } else {
            this.state.errors.confirmPassword = ''
            this.state.errorType.confirmPasswordClassName = ''
            this.setState({
                [e.target.name]: e.target.value,
            })
        }
    }

    handleChange = async e => {
        e.persist();
        const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;

        await this.setState({
            [e.target.name]: value,
        })
        if (this.state.confirmPassword !== '' && this.state.confirmPassword !== this.state.password) {
            this.state.errors.confirmPassword = 'password_not_match'
            this.state.errorType.confirmPasswordClassName = 'validation-error'
            this.setState({
                [this.state.errors.confirmPassword]: 'password_not_match',
                [this.state.errorType.confirmPasswordClassName]: 'validation-error'
            })
        } else {
            this.state.errors.confirmPassword = ''
            this.state.errorType.confirmPasswordClassName = ''
            this.setState({
                [this.state.errors.confirmPassword]: '',
                [this.state.errorType.confirmPasswordClassName]: ''
            })
        }

        // PASSWORD
        if (e.target.name === 'password') {
            if (typeof e.target.value !== "undefined") {
                let passwordRegex = new RegExp(this.state.passRegExpression);
                if (e.target.value !== '' && !passwordRegex.test(e.target.value)) {
                    this.state.errors.password = 'password_match_pattern'
                    this.state.errorType.passwordClassName = "";
                    this.setState({
                        [this.state.errors.password]: 'password_match_pattern',
                        [this.state.errorType.passwordClassName]: '',
                    })
                } else {
                    this.state.errors.password = ''
                    this.state.errorType.passwordClassName = "";
                    this.setState({
                        [this.state.errors.password]: '',
                        [this.state.errorType.passwordClassName]: ''
                    })
                }
            }
        }
    }

    verifyUsername = async e => {
        if ((e.target.value).match(/[\u0600-\u06FF\u0750-\u077F]/)) {
            this.state.errors.userName = 'arabic_not_allowed';
            this.state.errorType.userNameClassName = "api-error"

            this.setState({
                [this.state.errors.userName]: 'arabic_not_allowed',
                [this.state.errorType.userNameClassName]: "api-error"
            })
        } else {
            let requestBody = {
                "username": e.target.value
            }

            try {
                await this.setState({
                    loading: true
                })
                let result = await verifyUsername(requestBody)
                this.state.errors.userName = ''
                this.state.errorType.userNameClassName = ""

                this.setState({
                    [this.state.errors.userName]: '',
                    [this.state.errorType.userNameClassName]: "",
                    genericError: null,
                    loading: false
                })
            } catch (error) {
                this.state.errors.userName = error.message
                this.state.errorType.userNameClassName = "api-error"

                this.setState({
                    [this.state.errors.userName]: error.message,
                    [this.state.errorType.userNameClassName]: "api-error",
                    loading: false
                })

            }

            if (this.state.password !== "undefined" && this.state.userName !== '') {
                let passwordRegex = new RegExp("^(?=.*[0-9])(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z])((?!.*" + this.state.userName + ").*).{12,}$", "i");
                if (this.state.password !== '' && !this.state.password.match(passwordRegex)) {
                    this.state.errors.password = 'password_match_pattern';
                    this.state.errorType.passwordClassName = "validation-error";
                    this.setState({
                        [this.state.errors.password]: 'password_match_pattern',
                        [this.state.errorType.passwordClassName]: ""
                    })
                } else {
                    this.state.errors.password = '';
                    this.state.errorType.passwordClassName = "";
                    this.setState({
                        [this.state.errors.password]: '',
                        [this.state.errorType.passwordClassName]: ""
                    })
                }
            }
        }
    }

    recaptchaRef = createRef();

    render() {
        const { t, companyName } = this.props;

        return (
            <>
                {this.state.loading && <div className="loading">Loading&#8230;</div>}

                {!this.state.isSuccess && (
                    <>
                        <div className="loginIntroTextContainer corporate-reg-title">
                            <h3>
                                {t("welcome_business_title")}{" "}{companyName}
                            </h3>
                        </div>
                        <div className="tabs">
                            <div className="tab-content">
                                {this.state.genericError && (
                                    <>
                                        <ErrorAlert error={this.state.genericError} />
                                        <div style={{ display: "none" }} className={this.state.genericError ? "api-error" : ""}>{this.state.genericError}</div>
                                    </>
                                )}
                                <form onSubmit={this.handaleSubmit} id={"business-registration-form"}>

                                    {/* USERNAME FIELD */}
                                    <TextInput id={"username"} label={"username"} name={"userName"} value={this.state.userName} type={"text"} error={this.state.errors.userName} errorType={this.state.errorType.userNameClassName} handleChange={this.handleChange} handleBlur={this.verifyUsername} />

                                    {/* PASSWORD FIELD */}
                                    <TextInput id={"password"} label={"password"} name={"password"} value={this.state.password} type={"password"} error={this.state.errors.password} errorType={this.state.errorType.passwordClassName} handleChange={this.handleChange} tooltip={this.state.toolTipMessage} />
                                    <PasswordStrengthBar scoreWords={[t('weak'), t('weak'), t('okay'), t('good'), t('strong')]} shortScoreWord={t('too_short')} minLength={12} scoreWordStyle={{ color: 'white' }} password={this.state.password} />

                                    {/* CONFIRM PASSWORD FIELD */}
                                    <TextInput id={"confirmPassword"} label={"confirm_password"} name={"confirmPassword"} value={this.state.confirmPassword} type={"password"} error={this.state.errors.confirmPassword} errorType={this.state.errorType.confirmPasswordClassName} handleChange={this.handleConfirmPassword} />

                                    {/* EMAIL FIELD */}
                                    <SelectInput id="preferedLang" label={"prefered_lang"} name={"preferedLang"} value={this.state.preferedLang} type={"select"} error={this.state.errors.preferedLang} handleChange={this.handleChange} options={this.state.preferedLangOptions} />

                                    {/* ReCAPTCHA PART */}
                                    <ReCAPTCHA ref={this.recaptchaRef}
                                        className="mt-4"
                                        sitekey={window.INVISIBLE_CAPTCHA_V2_SITE_KEY}
                                        type="image"
                                        hl={window.lang === 'ar' ? "ar" : "en"}
                                        name={"recaptcha"}
                                    />

                                    {this.state.errors.recaptcha && (
                                        <>
                                            <ErrorAlert error={this.state.errors.recaptcha} />
                                            <div style={{ display: "none" }} className={this.state.errors.recaptcha ? this.state.errorType.recaptchaClassName : "api-error"}>{this.state.errorType.recaptchaClassName}</div>
                                        </>
                                    )}

                                    {/* TERMS AND CONDITION CHECKBOX */}
                                    <CheckBoxRadioInput id="termsConditions" label={"accept_statement"} terms={"terms_conditions"} name={"termsConditions"} value={this.state.termsConditions} type={"checkbox"} error={this.state.errors.termsConditions} errorType={this.state.errorType.termsConditionsClassName} handleChange={this.handleChange} />

                                    <button id="business-signup" type="submit" className="btn min_outlin_btn activationcodeButton active">
                                        {t("sign_up")} <i className="fa fa-arrow-right" aria-hidden="true"></i>
                                    </button>

                                </form>
                            </div>
                        </div>
                    </>
                )}
                {this.state.isSuccess && <SuccessScreen description={"enjoy_of_our_services_business"} loginUrl={this.state.loginUrl} />}
            </>
        )
    }
}

export default withTranslation()(BusinessBasicInfo);